import "./Button.css";

/*
  Button Component

  variant:
  primary  = الإجراء الأساسي مثل Save / Confirm
  success  = اعتماد / تفعيل / إكمال
  danger   = حذف / رفض / إزالة
  warning  = تنبيه / إجراء يحتاج انتباه
  neutral  = إجراء عادي أو ثانوي

  appearance:
  filled / soft / outline / ghost / text

  content:
  text فقط، icon فقط، أو icon + text
*/

const Button = ({
  children,
  variant = "primary",
  appearance = "soft",
  size = "md",
  icon,
  iconPosition = "start",
  loading = false,
  disabled = false,
  fullWidth = false,
  rounded = false,
  className = "",
  type = "button",
  title,
  ...props
}) => {
  const isIconOnly = icon && !children;

  return (
    <button
      type={type}
      title={title}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={`ui-button ${variant} ${appearance} ${size} ${
        fullWidth ? "ui-full-width" : ""
      } ${rounded ? "rounded" : ""} ${isIconOnly ? "icon-only" : ""} ${className}`}
      {...props}
    >
      {loading ? (
        <>
          <span className="ui-button-loader" aria-hidden="true" />
          {/* Keeps the button's accessible name while the text is replaced. */}
          {children && <span className="ui-button-sr">{children}</span>}
        </>
      ) : (
        <>
          {icon && iconPosition === "start" && (
            <span className="ui-button-icon">{icon}</span>
          )}

          {children && <span className="ui-button-text">{children}</span>}

          {icon && iconPosition === "end" && (
            <span className="ui-button-icon">{icon}</span>
          )}
        </>
      )}
    </button>
  );
};

export default Button;